@use '../../scss/utility';

@use './card-common';
@use './card-vars';

:host {
  @include card-vars.wb-card-vars;
  @include card-common.wb-card;

  @include utility.breakpoint-from('mq4') {
    @include card-vars.wb-card-vars-desktop;
  }
}

// Keeping old variants for compatibility

:host([variant='primary']),
:host([variant='white']),
:host([variant='dark-grey']) {
  @include card-vars.wb-card-primary-vars;
}

:host([variant='secondary']),
:host([variant='light-grey']) {
  @include card-vars.wb-card-secondary-vars;
}

:host([padded]) {
  @include card-common.wb-card-padded;
}

:host([interactive]) {
  @include card-common.wb-card-interactive;
}

:host([interactive]:hover) {
  @include card-common.wb-card-interactive-hover-active-focus;
}

:host([interactive]:active) {
  @include card-vars.wb-card-active-vars;
  @include card-common.wb-card-interactive-hover-active-focus;
}

:host([interactive]:focus-visible) {
  @include card-vars.wb-card-focus-vars;
  @include card-common.wb-card-interactive-hover-active-focus;
  @include card-common.wb-card-interactive-focus;
}

:host([interactive]:dir(rtl)) {
  @include card-common.wb-card-interactive-rtl;
}

:host([interactive][variant='primary']:hover),
:host([interactive][variant='white']:hover),
:host([interactive][variant='dark-grey']:hover) {
  @include card-vars.wb-card-primary-hover-vars;
}

:host([interactive][variant='primary']:focus-visible),
:host([interactive][variant='white']:focus-visible),
:host([interactive][variant='dark-grey']:focus-visible) {
  @include card-vars.wb-card-primary-focus-vars;
}

:host([interactive][variant='primary']:active),
:host([interactive][variant='white']:active),
:host([interactive][variant='dark-grey']:active) {
  @include card-vars.wb-card-primary-active-vars;
}

:host([interactive][variant='secondary']:hover),
:host([interactive][variant='light-grey']:hover) {
  @include card-vars.wb-card-secondary-hover-vars;
}

:host([interactive][variant='secondary']:focus-visible),
:host([interactive][variant='light-grey']:focus-visible) {
  @include card-vars.wb-card-secondary-focus-vars;
}

:host([interactive][variant='secondary']:active),
:host([interactive][variant='light-grey']:active) {
  @include card-vars.wb-card-secondary-active-vars;
}
